// removed by extract-text-webpack-plugin
module.exports = {"mainContentContainer":"src-pages-klub----skupine-module---mainContentContainer---36tXV","mainContent":"src-pages-klub----skupine-module---mainContent---1Tqk_","imageContainer":"src-pages-klub----skupine-module---imageContainer---2UhAC"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/klub/skupine.module.css
// module id = 271
// module chunks = 37913953040966 59956827976669